import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
//@ts-ignore
import styles from './pricing.module.css'

interface IPricingCard {
    title: string;
    pricingText: string;
    buttonText: string;
    buttonUrl: string;
    description: string;
}
/**Returns an array of nodes */
const usePricingQuery = (): Array<IPricingCard> => {
    const data = useStaticQuery(graphql`
        query PricingCards {
            allContentfulPricingCards(filter: {salesWebsiteOnly: {eq: false}}) {
            nodes {
                title
                pricingText
                buttonText
                buttonUrl
                description
            }
            }
        }
    `);

    return data?.allContentfulPricingCards?.nodes as Array<IPricingCard>
}

const PricingCard: React.FunctionComponent<{data: IPricingCard}> = ({data}) => {
    return (
        <div className={styles.pricingCard}>
            <span className={styles.cardTitle}>{data.title}</span>
            <div className={styles.pricingGroup}>
                <span className={styles.priceText}>{data.pricingText}</span>
                <span className={styles.descText}>{data.description}</span>
            </div>
            {data.buttonText && 
                <a href={data.buttonUrl} className={styles.button}>{data.buttonText}</a>
            }

        </div>
    )
}
export const Pricing: React.FunctionComponent = (props) => {
    const cards = usePricingQuery();
    return(
        <section className={styles.pricingSection} id="pricing_section">
            <p className={styles.sectionHeaderText}>Pricing</p>
            <div className={styles.pricingContainer}>
                {
                    cards?.map((card, _) => {
                        return <PricingCard data={card}/>
                    })
                }
            </div>
        </section>
    )
}